import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region DATE

function _Date(props) { return <LabelValue {...props} value={props.content} /> }
const Date = withLabelTokenParsing(_Date, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            replaceString = data.Date;
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Date', token: Token.Date }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: (display) => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: display || 'Date:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}}`, token: Token.Date }))
    }
};

// #endregion DATE

export {
    Date as Component,
    Tokens,
    TypeConfig
}